import { TitleButton } from 'src/components/atomsLegacy';
import { TitleText as TitleTextStyle } from 'src/components/atomsLegacy/typography/TitleText/TitleText.styles';
import styled from 'styled-components';

export const RightBoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  border: 1px solid white;
  background: ${(props) => props.theme.newPalette.neutral.N0};
  border-radius: 8px;
`;
export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 14px 0px 15px 24px;
  border-bottom: 1px solid ${(props) => props.theme.newPalette.neutral.N300};
  align-items: center;
`;

export const Title = styled(TitleTextStyle)`
  margin: 24px 0px;
`;

export const Divider = styled.span`
  border: 1px solid ${(props) => props.theme.newPalette.neutral.N300};
  transform: rotate(-90deg);
  width: 24px;
  height: 0px;
  margin-right: 10px;
  margin-left: 10px;
`;

export const NewTitleButton = styled(TitleButton)<{
  selected?: boolean;
  weight?: string;
  noMargin?: boolean;
}>`
  display: flex;
  flex-direction: row;
  font-family: ${(props) => props.theme.typography.fontFamily};
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
  font-size: 16px;
  font-weight: ${(props) => (props.weight === 'regular' ? '400' : '300')};
  margin: ${(props) => (props.noMargin ? '0px' : '5px')};
  color: ${(props) =>
    props.selected
      ? props.theme.newPalette.neutral.N800
      : props.theme.newPalette.neutral.N500};
  white-space: nowrap;
  gap: 8px;
  height: 20px;
`;
